import { render } from "./EditAfterDepartureSideNav.vue?vue&type=template&id=ce7a023c"
import script from "./EditAfterDepartureSideNav.vue?vue&type=script&lang=js"
export * from "./EditAfterDepartureSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__